import React from "react";
import { ArrowRight } from "lucide-react";

const HERO = "https://static.prod-images.emergentagent.com/jobs/86dbb7be-8e31-4f59-a434-2b11ea866542/images/8a58b8b5e120d9d5699bf253637a2b409731fffdb470fd463f9453530e083e41.png";

export default function Hero({ onBook }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-end pb-24 md:pb-32 pt-32">
        <p className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-6" data-testid="hero-eyebrow">
          Wilton Manors · Lounge &amp; Live Music
        </p>
        <h1 className="font-serif font-light text-white text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-none max-w-5xl">
          Next Bar &amp; <span className="italic text-[#D4AF37]">Lounge</span>
        </h1>
        <p className="mt-8 max-w-xl text-neutral-300 text-base md:text-lg leading-relaxed">
          Intimate nights, big energy on Wilton Drive. Crafted cocktails, small plates and live entertainment in an
          upscale lounge built around atmosphere over volume.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <button
            onClick={onBook}
            data-testid="hero-book-btn"
            className="group inline-flex items-center gap-3 bg-[#D4AF37] text-black font-medium tracking-[0.2em] uppercase text-xs py-4 px-8 hover:bg-[#C5A028] transition-colors"
          >
            Book a Private Event
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="#entertainment"
            data-testid="hero-lineup-btn"
            className="inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] font-medium tracking-[0.2em] uppercase text-xs py-4 px-8 hover:bg-[#D4AF37] hover:text-black transition-colors"
          >
            Tonight's Lineup
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 right-6 md:right-12 z-10 hidden sm:flex items-center gap-3 text-neutral-400">
        <div className="h-px w-12 bg-[#D4AF37]" />
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
      </div>
    </section>
  );
}
